import React from 'react';
import { motion } from 'framer-motion';

const Loading = ({ progress = 0 }) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-cream">
      <motion.div
        className="text-center max-w-md px-8"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <motion.div
          className="w-16 h-16 border-4 border-sage border-t-transparent rounded-full mx-auto mb-6"
          animate={{ rotate: 360 }}
          transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
        />
        <p className="text-sage-dark text-lg font-display italic mb-4">
          Loading your invitation...
        </p>

        {/* Progress Bar */}
        <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
          <motion.div
            className="h-full bg-sage"
            initial={{ width: 0 }}
            animate={{ width: `${progress}%` }}
            transition={{ duration: 0.3 }}
          />
        </div>
        <p className="text-sage-dark text-sm mt-2">{Math.round(progress)}%</p>
      </motion.div>
    </div>
  );
};

export default Loading;
